import React from "react";

import { Table, Typography, Tooltip } from "antd";
import { sub, round } from "../../../core/utils/currency";

const { Text, Title } = Typography;

const columnsManual = [
    {
        title: "Amount",
        dataIndex: "amountValue",
        key: "amountValue",
        align: "right",
    },
];

const columnsPO = [
    {
        title: "Description",
        dataIndex: "task",
        key: "task",
        render: (task, record) => (
            <Tooltip title={record.name}>
                <Text>{task}</Text>
            </Tooltip>
        ),
    },
    {
        title: "#",
        dataIndex: "quantity",
        key: "quantity",
        align: "right",
        width: 50,
    },
    {
        title: "Unit",
        dataIndex: "unit",
        key: "unit",
        align: "right",
        width: 50,
    },
    {
        title: "Rate",
        dataIndex: "rateValue",
        key: "rateValue",
        align: "right",
        width: 150,
    },
    {
        title: "Subtotal",
        dataIndex: "subtotalValue",
        key: "subtotalValue",
        align: "right",
        width: 150,
    },
];

export const expandFromInvoice = (record) => {
    const details = record.type == "PURCHASE ORDER" ? record.purchaseOrderDetails : record.details;
    const columns = record.type == "PURCHASE ORDER" ? columnsPO : columnsManual;

    return <Table columns={columns} rowKey={(record) => record.id} dataSource={details || []} pagination={false} />;
};

export const expandPurchaseOrderDetailsFromInvoiceDetail = (record) => {
    const list = record.purchaseOrderDetails || [];
    const receivables = record.purchaseOrderDetails || [];

    const uncompensatedAmount = Number.parseFloat(record.job.totalToReceiveValue - record.job.balanceClient).toFixed(4);
    const uncompensatedStatus =
        uncompensatedAmount > 0.00001 ? "success" : uncompensatedAmount < -0.00001 ? "danger" : "";

    return (
        <Table
            columns={columnsPO}
            rowKey={(record) => record.id}
            dataSource={list || []}
            pagination={false}
            title={() => <Title level={5}>Purchase Order</Title>}
            summary={() => {
                return (
                    <>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Subtotal</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>
                                    {record.amountValue} {record.amountType}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={5}>
                                <Text strong>Job Finances </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>

                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Receivables</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>
                                    {record.job?.totalToReceiveValue} {record.amountType}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>

                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Invoiced</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>
                                    {record.job?.balanceClient} {record.amountType}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                        <Table.Summary.Row>
                            <Table.Summary.Cell colSpan={3}></Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text strong>Uncompensated</Text>
                            </Table.Summary.Cell>
                            <Table.Summary.Cell align="right">
                                <Text type={uncompensatedStatus}>
                                    {uncompensatedAmount} {record.job.totalToReceiveType}
                                </Text>
                            </Table.Summary.Cell>
                        </Table.Summary.Row>
                    </>
                );
            }}
        />
    );
};
